// extracted by mini-css-extract-plugin
export default {"yourIncomeDisclaimer":"YourIncome_yourIncomeDisclaimer__W0Gur","skeletonLoadingAnimation":"YourIncome_skeletonLoadingAnimation__NnyVF"};